import { useToast } from '@chakra-ui/react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import createFaq from 'services/Admin/Faqs/createFaq';
import deleteFaq from 'services/Admin/Faqs/deleteFaq';
import allFaqs from 'services/Admin/Faqs/getAllFaq';
import getFaqsByType from 'services/Admin/Faqs/getFaqsByType';

import updateFaq from 'services/Admin/Faqs/updateFaq';

export const useGetAllFaqs = (featured?: boolean) => {
    const { data, isLoading, ...rest } = useQuery(['getAllFaqs', featured], () => allFaqs(featured));
    return { faqs: data, isLoading, ...rest };
};

export const useGetFaqsByType = (type?: string) => {
    const { data, isLoading, ...rest } = useQuery(['getFaqsByType', type], () => getFaqsByType(type));
    return { faqs: data, isLoading, ...rest };
};

export const useUpdateFaq = () => {
    const toast = useToast();
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const onSuccess = () => {
        toast({ title: 'Faq Updated Successfully', status: 'success' });
        queryClient.removeQueries({
            queryKey: ['getAllFaqs'],
        });
        navigate('/admin/faq');
    };

    const onError = (error: any) => {
        toast({ title: error?.response?.data?.message || 'Some error while updating the faq', status: 'error' });
    };
    const { mutateAsync, isLoading } = useMutation(updateFaq, { onSuccess, onError });
    return { updateFaq: mutateAsync, isLoading };
};

export const useCreateFaq = () => {
    const toast = useToast();
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const onSuccess = () => {
        toast({ title: 'Faq created!!', status: 'success' });
        queryClient.removeQueries({
            queryKey: ['getAllFaqs'],
        });
        navigate('/admin/faq');
    };

    const onError = (error: any) => {
        toast({ title: error?.response?.data?.message || 'Some error while creating the faq', status: 'error' });
    };

    const { mutateAsync, isLoading } = useMutation(createFaq, { onSuccess, onError });
    return { createFaq: mutateAsync, isLoading };
};

export const useDeleteFaq = () => {
    const toast = useToast();
    const queryClient = useQueryClient();

    const onSuccess = () => {
        toast({ title: 'Faq deleted!!', status: 'success' });
        queryClient.removeQueries({
            queryKey: ['getAllFaqs'],
        });
    };

    const onError = () => {
        toast({ title: 'Error deleting faq!', status: 'error' });
    };

    const { mutate, isLoading } = useMutation(deleteFaq, {
        onSuccess,
        onError,
    });

    const faqDelete = (id: string) => {
        mutate({ id });
    };

    return { faqDelete, isLoading };
};
